import { company } from "titum-custom/details";
import React from "react";
import "./style-report.css";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
export default function Reports({ children, title = "Reports" }) {
  const today = new Date();

  return (
    <div>
      {/* <div className="r-page-header print-only-first-page">
        <h1>{company.name} | {company.address} | {company.phone}</h1>
        <div className="space-between">
          <p>Date: &nbsp; {today.toDateString()}</p>
          <p>Time: &nbsp; {today.toLocaleTimeString()}</p>
        </div>
      </div>

      <div className="r-page-footer">
       `{TitumDetails.SOLUTION_BY} | {TitumDetails.PHONE_NO} | {TitumDetails.EMAIL_ID}`
      </div> */}

      <table style={{minWidth: "100%"}}>
        {/* <thead>
          <tr>
            <td>
              <div className="r-page-header-space"></div>
            </td>
          </tr>
        </thead> */}

         <thead>
          <tr>
            <td>
                <div style={{border:"1px solid black", padding:5}}>
                  <h1>{company.name} | {company.address} | {company.phone}</h1>
                  <div className="space-between">
                    <p>Date: &nbsp; {today.toDateString()}</p>
                    <p>Time: &nbsp; {today.toLocaleTimeString()}</p>
                  </div>
                </div>

                <div className="r-page-footer">
                `{TitumDetails.SOLUTION_BY} | {TitumDetails.PHONE_NO} | {TitumDetails.EMAIL_ID}`
                </div>
            </td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <div className="r-page">
                <h1 style={{ textAlign: "center", marginBottom: 10, marginTop: 30 }}>
                  {title}
                </h1>
                {children}
              </div>
            </td>
          </tr>
        </tbody>

        {/* <tfoot>
          <tr>
            <td>
              <div className="r-page-footer-space"></div>
            </td>
          </tr>
        </tfoot> */}
      </table>
    </div>
  );
}
